{
  "Accessibility Menu": "Meni dostopnosti",
  "Reset settings": "Ponastavi nastavitve",
  "Close": "Zapri",
  "Content Adjustments": "Prilagoditve vsebine",
  "Adjust Font Size": "Prilagodi velikost pisave",
  "Highlight Title": "Označi naslov",
  "Highlight Links": "Označi povezave",
  "Readable Font": "Bralna pisava",
  "Color Adjustments": "Prilagoditve barv",
  "Dark Contrast": "Temni kontrast",
  "Light Contrast": "Svetli kontrast",
  "High Contrast": "Visoki kontrast",
  "High Saturation": "Visoka nasičenost",
  "Low Saturation": "Nizka nasičenost",
  "Monochrome": "Monokromno",
  "Contrast": "විරුද්ධතාව",
  "Invert Colors": "වර්ණ පෙරලන්න",
  "Tools": "Orodja",
  "Reading Guide": "Bralni vodnik",
  "Stop Animations": "Ustavi animacije",
  "Big Cursor": "Velik kazalec",
  "Increase Font Size": "Povečaj velikost pisave",
  "Decrease Font Size": "Zmanjšaj velikost pisave",
  "Letter Spacing": "Razmik med črkami",
  "Line Height": "Višina vrstice",
  "Font Weight": "Debelina pisave",
  "Dyslexia Font": "Pisava za disleksijo",
  "Language": "Jezik",
  "Open Accessibility Menu": "Odpri meni dostopnosti",
  "Widget Settings": "විජට් සැකසුම්",
  "Widget Position": "විජට් පිහිටුම",
  "Top Left": "ඉහළ වම",
  "Top Center": "ඉහළ මධ්‍යය",
  "Top Right": "ඉහළ දකුණ",
  "Center Left": "මධ්‍ය වම",
  "Center Right": "මධ්‍ය දකුණ",
  "Bottom Left": "පහළ වම",
  "Bottom Center": "පහළ මධ්‍යය",
  "Bottom Right": "පහළ දකුණ",
  "Screen Reader": "තිර කියවනය",
  "Voice Navigation": "හඬ නාවිගේෂන්",
  "Custom Color": "අභිරුචි වර්ණය",
  "Change the site's colors": "වෙබ්අඩවියේ වර්ණ වෙනස් කරන්න",
  "Backgrounds": "පසුබිම්",
  "Headings": "ශීර්ෂක",
  "Contents": "අන්තර්ගත",
  "Reset colors": "වර්ණ නැවත සකසන්න",
  "Image Desaturation": "පිංතූරයේ වර්ණය අඩු කිරීම",
  "Search languages": "භාෂා සොයන්න",
  "No languages found": "භාෂා කිසිවක් හමු නොවුණි",
  "Accessibility Profiles": "ප්‍රවේශය සඳහා පැතිකඩ",
  "Motor Impaired": "මෝටර් අසමත්",
  "Big cursor, voice navigation, and no animations.": "විශාල දර්ශකය, හඬ නාවිකත්වය සහ අනිමේෂන් නැත.",
  "Blind": "කුරුළු",
  "Screen reader helpers with higher contrast.": "ඉහළ විරුද්ධතාවයකින් යුත් තිර කියවීම් උදව්කරුවෝ.",
  "Color Blind": "වර්ණ අන්ධතාව",
  "High contrast palette with desaturated media.": "ඉහළ විරෝධී පේලට් සහ අඩු සන්තුලිත මාධ්‍ය.",
  "Dyslexia": "ඩිස්ලෙක්සියා",
  "Friendly font, extra spacing, stronger weight.": "කියවීමට පහසු අක්‌ෂර, අමතර ඉඩ හා තදකම.",
  "Low vision": "අව කാഴ്ച",
  "Dark contrast and 130% magnification.": "අඳුරු විරෝධය සහ 130% විශාල කිරීම.",
  "Cognitive & Learning": "ඥානීය හා ඉගෙනීම",
  "Highlights key sections and enables voice help.": "ප්‍රධාන කොටස් හිරුපැහැ කර හඬ සහාය සක්‍රීය කරයි.",
  "Seizure & Epileptic": "අච්චු සහ මිනරන්",
  "Stops animations and desaturates imagery.": "ජීවීකරු නවත්වමින් පින්තූරයේ පෙලසුම් අඩු කරයි.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "කියවීමේ මාර්ගෝපදේශය, ඉස්මතු කරන ලද සබැඳි සහ සමනයිත පාලට්.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
